import { connect } from 'react-redux';

import { companyOverviewActions } from 'dataflow/distributorPortal/actions';

import { CompanyOverviewPresentation } from './CompanyOverviewPresentation';

function mapStateToProps(state) {
    const { 
        getOutletList_requesting, 
        outletList, outletListHeaders,

        getLicenseList_requesting, 
        licenseList, licenseListHeaders,

        getPackageList_requesting, 
        packageList,

        addOutlet_requesting,
        addOutlet_status,

        addLicense_requesting,
        addLicense_status,

        resetLicense_requesting,
        resetLicense_status,

        deleteLicense_requesting, 
        deleteLicense_status,

        updateLicenseRemark_requesting,
        updateLicenseRemark_status,

        changeCompanyStatus_requesting,

        suspendCOM_status
    } = state.distributorPortal_companyOverviewReducers;

	return {
        getOutletList_requesting, 
        outletList, outletListHeaders,

        getLicenseList_requesting, 
        licenseList, licenseListHeaders,

        getPackageList_requesting, 
        packageList,

        addOutlet_requesting,
        addOutlet_status,

        addLicense_requesting,
        addLicense_status,

        resetLicense_requesting,
        resetLicense_status,

        deleteLicense_requesting, 
        deleteLicense_status,

        updateLicenseRemark_requesting,
        updateLicenseRemark_status,

        changeCompanyStatus_requesting,

        suspendCOM_status
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getOutletList: (comID, pageNo, pageSize, sort, filterOptions) => { dispatch(companyOverviewActions.getOutletList(comID, pageNo, pageSize, sort, filterOptions)); },
        getLicenseList: (comID, pageNo, pageSize, sort, filterOptions) => { dispatch(companyOverviewActions.getLicenseList(comID, pageNo, pageSize, sort, filterOptions)); },
        getPackageList: () => { dispatch(companyOverviewActions.getPackageList()); },

        addOutlet: (outletInfoObj) => { dispatch(companyOverviewActions.addOutlet(outletInfoObj)); },
        addLicense: (licenseInfo) => { dispatch(companyOverviewActions.addLicense(licenseInfo)); },
        resetLicense: (licenseInfo) => { dispatch(companyOverviewActions.resetLicense(licenseInfo)); },
        deleteLicense: (licenseInfo) => { dispatch(companyOverviewActions.deleteLicense(licenseInfo)); },
        updateLicenseRemark: (id, licenseInfo) => { dispatch(companyOverviewActions.updateLicenseRemark(id, licenseInfo)); },

        suspendCOM: (comID) => { dispatch(companyOverviewActions.suspendCOM(comID)); },
        changeCompanyStatus: (comID, status) => { dispatch(companyOverviewActions.changeCompanyStatus(comID, status)); }
    };
}

const CompanyOverview = connect(mapStateToProps, mapDispatchToProps)(CompanyOverviewPresentation);

export default CompanyOverview;